import { render, staticRenderFns } from "./weddingForm.vue?vue&type=template&id=3954c034&"
import script from "./weddingForm.vue?vue&type=script&lang=js&"
export * from "./weddingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports